function mixImmediate(a, b) {
    return (p) => (p > 0 ? b : a);
}

export { mixImmediate };
